export default __webpack_public_path__ + "static/media/euler-logo.4cd998c6.png";